import React, { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import "./LegalPages.css";

const PrivacyPolicy = () => {
    const [title, setTitle] = useState("Privacy Policy");
    const [content, setContent] = useState("");
    const [lastUpdated, setLastUpdated] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    useEffect(() => {
        const fetchPolicy = async () => {
            try {
                const response = await fetch(
                    "https://admin.newalliedtour.net/api/privacy_policy/"
                );
                const data = await response.json();

                if (data) {
                    setTitle(data.title || "Privacy Policy");
                    // Sanitize HTML content for security
                    const cleanContent = DOMPurify.sanitize(data.content || "", {
                        ALLOWED_TAGS: ["h1", "h2", "h3", "h4", "h5", "h6", "p", "ul", "ol", "li", "b", "strong", "em", "i", "u", "span", "br", "hr", "a"],
                        ALLOWED_ATTR: ["style", "class", "href", "target"]
                    });
                    setContent(cleanContent);

                    // Format date
                    if (data.last_updated) {
                        const date = new Date(data.last_updated);
                        setLastUpdated(date.toLocaleDateString("en-US", {
                            year: "numeric",
                            month: "long",
                            day: "numeric"
                        }));
                    }
                }
            } catch (error) {
                console.error("Error fetching privacy policy:", error);
                setContent("<p>Unable to load content. Please try again later.</p>");
            } finally {
                setLoading(false);
            }
        };

        fetchPolicy();
    }, []);

    if (loading) {
        return (
            <div className="legal-page">
                <div className="legal-container">
                    <p>Loading...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="legal-page">
            <div className="legal-container">
                <h1>{title}</h1>
                {lastUpdated && (
                    <p className="last-updated">Last Updated: {lastUpdated}</p>
                )}
                <div
                    className="legal-content"
                    dangerouslySetInnerHTML={{ __html: content }}
                />
            </div>
        </div>
    );
};

export default PrivacyPolicy;
